import {initSliders} from './Slider.js';

/**
 * Страница новостей
 * ***/

const $newsFilter = $('.js-news-filter');
const $popupFilter = $('.js-popup[data-type="datepicker"]');
const $filterWrapper = $('.js-filter-wrapper');
const $dateFilter = $newsFilter.find('.js-date-filter');
const $dateToggler = $newsFilter.find('.js-date-toggler');
const $dateInputs = $dateFilter.find('input');
const $newsItemTitles = $('.news-item__title');
const $pageInput = $('.js-page-input');

if ($newsFilter.length) {
    const $filterBtn = $('.js-filter-btn');
    const $pageNextBtn = $('.js-page-next-btn');
    const $sort = $('.js-sort');

    /* при выборе типа сортировки подгружаем новости */
    $sort.on('change', function (e) {
        $pageInput.val(1);
        loadNews();

        e.preventDefault();
    });

    /* клик по кнопке фильтре, отправляем запрос */
    $filterBtn.on('click', function (e) {
        loadNews();

        e.preventDefault();
    });

    /* отправка формы фильтра, отправляем запрос */
    $newsFilter.on('submit', function (e) {
        loadNews();

        e.preventDefault();
    });

    /* навешиваем кастомное событие, используется при сбросе даты фильтрации через datePicker (см. в UI.js) */
    App.W.on('news:filter', function () {
        loadNews();
    });
}

/* при клике "показать еще" увеличиваем текущую страницу на 1 и отправляем запрос */
$filterWrapper.on('click', '.js-page-next-btn', function (e) {
    let currentPage = parseInt($pageInput.val());

    $pageInput.val(currentPage + 1);
    loadNews(true);

    e.preventDefault();
});

if ($newsItemTitles.length) {
    $newsItemTitles.each(function () {
        const $currTitle = $(this);
        const currTitleText = $currTitle.html();
        const currHeight = parseInt($currTitle.css('height')) ? parseInt($currTitle.css('height')) : parseInt($currTitle.css('max-height'));

        $currTitle.html(`<span>${currTitleText}</span>`);

        if ($currTitle.find('span').outerHeight() <= currHeight) {
            $currTitle.addClass('no-fade');
        }
    });
}

/***
 * @addContent — флаг показываем добавлять контент в блок или заменить контент в блоке новым
 * */
function loadNews(addContent) {
    let basicUrl = $newsFilter.data('basic-url') || (location.origin + location.pathname);

    basicUrl = basicUrl.indexOf('?') > 0 ? $newsFilter.data('basic-url') + '&' : $newsFilter.data('basic-url') + '?';
    App.H.addClass('_loading');

    if ($dateFilter.is('._selected')) {
        $dateInputs.removeAttr('disabled');
    } else {
        $dateInputs.prop('disabled', true);
    }

    if ($popupFilter.is('._open')) {
        $popupFilter.find('.js-popup-close').trigger('click');
    }

    $.ajax({
        url: $newsFilter.attr('action'),
        data: $newsFilter.serialize(),
        type: $newsFilter.attr('method') || 'GET',
        cache: false,
        success: (response) => {
            const $response = $(response);

            if ($response.find('.js-filter-wrapper').length) {
                const filterContent = $response.find('.js-filter-wrapper').html();
                const newPageNum = $response.find('.js-page-input').val();

                if (addContent && $response.find('.js-news-wrapper-1').length) {
                    const $newsWrapper1 = $('.page-news-display-option-1 .js-news-wrapper-1');
                    const $newsWrapper2 = $('.page-news-display-option-2 .js-news-wrapper-2');
                    const newContent1 = $response.find('.page-news-display-option-1 .page-news-main-wrapper .page-news-wrapper__other-news .text-news').html();
                    const newContent2 = $response.find('.page-news-display-option-2 .page-news-main-wrapper').html();

                    $newsWrapper1.append(newContent1);
                    $newsWrapper2.append(newContent2);
                } else {
                    // App.H.addClass('_filtered-news');
                    $filterWrapper.html(filterContent);

                    initSliders($filterWrapper.find('.js-slider'));

                    if ($dateToggler.prop("checked")) {
                        $filterWrapper.find('.page-news-display-option-1').addClass('hidden');
                        $filterWrapper.find('.page-news-display-option-2').removeClass('hidden');
                    } else {
                        $filterWrapper.find('.page-news-display-option-1').removeClass('hidden');
                        $filterWrapper.find('.page-news-display-option-2').addClass('hidden');
                    }
                }

                if (window.history) {
                    history.pushState({param: 'Value'}, '', basicUrl + $newsFilter.serialize());
                }

                $('.js-page-input').val(newPageNum);

                
                if ($response.find('.js-page-next-btn').length) {
                    $('.js-page-next-btn').show();
                } else {
                    $('.js-page-next-btn').hide();
                }

            } else {
                console.log('Ошибка получения данных');
            }

            App.H.removeClass('_loading');
        },
        error: () => {
            console.log('Ошибка загрузки новостей');
            App.H.removeClass('_loading');
        }
    });
}

/**
 * Логика toggle-кнопки "Show by date"
 * */

$("#toggle-button").click(function() {
    if ($(this).is(':checked')){
        $('.page-news-display-option-1').fadeOut(500);
        $('.page-news-display-option-2').fadeIn(500);
    } else {
        $('.page-news-display-option-1').fadeIn(500);
        $('.page-news-display-option-2').fadeOut(500);
    }
});


// WEBPACK FOOTER //
// ./_src/js/NewsPage.js